<template>
  <div class="crisisWarning">
    <div class="breadcrumb">
      <axe-breadcrumb separator-class="el-icon-arrow-right">
        <axe-breadcrumb-item to="/measure/inventoryList">心育测评</axe-breadcrumb-item>
        <axe-breadcrumb-item>预警关注</axe-breadcrumb-item>
      </axe-breadcrumb>
    </div>
    <div class="title">
      预警关注<span>学校开展心理普测后，产生预警信息的学生，会出现在表单中，请您进行关注。</span>
    </div>
    <!-- 查询 -->
    <!-- 危险预警列表 -->
    <div class="tables">
      <div class="tabs">
        <axe-tabs
          v-model="tabWarnStatus"
          @tab-click="tabClick"
        >
          <axe-tab-pane
            label="待处理"
            name=10
          > </axe-tab-pane>
          <axe-tab-pane
            :disabled="!otherDataExist"
            label="处理中"
            name=30
          > </axe-tab-pane>
          <axe-tab-pane
            :disabled="!otherDataExist"
            label="已完成"
            name=40
          ></axe-tab-pane>
        </axe-tabs>
        <div
          class="no-warning-data"
          v-if="tableData.length===0"
        >
          <img src="@/assets/images/no-data.png" />
          <div v-if="otherDataExist">
            暂无处理的预警信息,您可以了解正在
            <span @click="goWarnStatus(30)">处理中</span> 或
            <span @click="goWarnStatus(40)">已完成</span> 的预警关注
          </div>
          <div v-else>暂无处理的预警信息</div>
        </div>
        <template v-else>
          <axe-form
            inline
            size="
            small"
            class="query-form"
            :model="queryForm"
          >
            <axe-form-item label="预警等级">
              <axe-select
                class="form-item-select"
                size="small"
                v-model="queryForm.warningLevel"
                placeholder="预警等级"
              >
                <axe-option
                  v-for="item in warningLevelOptions"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                >
                </axe-option>
              </axe-select>
            </axe-form-item>
            <axe-form-item label="预警来源">
              <axe-select
                class="form-item-select"
                size="small"
                v-model="queryForm.sourceId"
                placeholder="预警来源"
                :disabled="!isTeacher && !queryForm.schoolId"
              >
                <axe-option
                  v-for="item in warningSourceOptions"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                >
                </axe-option>
              </axe-select>
            </axe-form-item>
            <axe-form-item class="keyWord">
              <axe-input
                class="form-item-select"
                v-model="queryForm.userName"
                size="small"
                placeholder="请输入学生姓名"
              ></axe-input>
            </axe-form-item>
            <div></div>
            <axe-form-item :label="isTeacher ? '选择班级':'选择年级'">
              <axe-select
                class="form-item-select"
                v-model="queryForm.gradeId"
                size="small"
                placeholder="选择年级"
                @change="selectGradeAndGetClassOptions"
              >
                <axe-option
                  label="全部"
                  value='all'
                >
                </axe-option>
                <axe-option
                  v-for="item in gradeOptions"
                  :key="item.code"
                  :label="item.name"
                  :value="item.code"
                >
                </axe-option>
              </axe-select>
              <div
                v-if="isTeacher"
                class="class-select"
              >
                <axe-select
                  class="form-item-select"
                  size="small"
                  v-model="queryForm.classId"
                  placeholder="班级"
                  :disabled="!queryForm.gradeId || queryForm.gradeId === 'all'"
                >
                  <axe-option
                    v-for="item in classOptions"
                    :key="item.code"
                    :label="item.name"
                    :value="item.code"
                  >
                  </axe-option>
                </axe-select>
              </div>
            </axe-form-item>

            <axe-form-item class="fr">
              <axe-button
                class="submit-btn"
                size="small"
                @click="resetQuery"
              >重置</axe-button>
              <axe-button
                class="submit-btn"
                type="primary"
                size="small"
                @click="getData(true)"
              >搜索</axe-button>
            </axe-form-item>
          </axe-form>
          <!-- 危险预警列表 -->
          <div class="tables">
            <axe-table
              :data="tableData"
              :loading="tableLoading"
              style="width: 100%"
            >
              <axe-table-column
                label="预警等级"
                width="100"
              >
                <template slot-scope="scope">
                  <div :class="[
                      'warning-level-block',
                      getWarningStyle(scope.row.warningLevel),
                    ]">
                    <img />{{ scope.row.warningLevelStr }}
                  </div>
                </template>
              </axe-table-column>
              <axe-table-column
                label="姓名"
                min-width="100"
                prop="userName"
                show-overflow-tooltip
              >
                <template slot-scope="scope">

                  <axe-button
                    v-if="isTeacher"
                    type="text"
                    @click="openPsychology(scope.row)"
                  >{{
                    scope.row.userName
                  }}</axe-button>
                  <span v-else>{{scope.row.userName}}</span>
                </template>
              </axe-table-column>
              <axe-table-column
                prop="sex"
                label="性别"
                min-width="50"
              >
                <template slot-scope="scoped">{{
                  scoped.row.sex === 0
                    ? "女"
                    : scoped.row.sex === 1
                    ? "男"
                    : "暂无"
                }}</template>
              </axe-table-column>
              <axe-table-column
                prop="className"
                label="班级"
                min-width="100"
                show-overflow-tooltip
              >
                <template slot-scope="scoped">{{
                  (scoped.row.gradeName|| '' )+ scoped.row.className
                }}</template>
              </axe-table-column>
              <axe-table-column
                prop="sourceName"
                label="预警来源"
                min-width="150"
                show-overflow-tooltip
              >
              </axe-table-column>

              <axe-table-column
                :label="modifyTimeTitle"
                width="140"
                show-overflow-tooltip
              >
                <template slot-scope="scoped">{{
                  scoped.row &&
                  $moment(scoped.row.modifyTime).format("YYYY-MM-DD HH:mm")
                }}</template>
              </axe-table-column>
              <axe-table-column
                prop="modifyUser"
                label="教师"
                min-width="100"
                v-if="queryForm.warnStatus === 30"
                show-overflow-tooltip
              >
              </axe-table-column>
              <axe-table-column
                label="操作"
                min-width="150"
              >
                <template slot-scope="scope">
                  <axe-button
                    v-if="queryForm.warnStatus === 10"
                    class="opeatBtn"
                    @click="warningDetail(scope.row)"
                    type="text"
                  >预警处理</axe-button>
                  <axe-button
                    v-if="[30, 40].includes(queryForm.warnStatus)"
                    class="opeatBtn"
                    @click="warningDetail(scope.row)"
                    type="text"
                  >关注记录</axe-button>
                  <axe-button
                    v-if="[10, 30].includes(queryForm.warnStatus)"
                    class="opeatBtn"
                    type="text"
                    @click="cancelWarningBtn(scope.row)"
                  >取消预警</axe-button>
                </template>
              </axe-table-column>
            </axe-table>
          </div>

          <!-- 分页 -->
          <Pagination
            ref="pageNation"
            :pageSize="page.pageSize"
            :pageNum="page.pageNo"
            :total="total"
            @handleCurrent="handleCurrent"
          />
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import Pagination from "@/components/pagination";

export default {
  props: {},
  components: {
    Pagination,
  },
  data () {
    return {
      warningLevelOptions: [
        { name: '全部', value: 'all', },
        { name: "一级预警", value: 1, },
        { name: "二级预警", value: 2, },
        { name: "三级预警", value: 3, },
      ],
      queryForm: {
        schoolId: "", // 学校
        gradeId: "all", // 年级
        classId: "all", // 班级
        userName: "", // 姓名
        warningLevel: "all", // 预警等级
        sourceId: "all", // 预警来源id
        warnStatus: 10, //当前tab页状态
      }, //查询列表
      tabWarnStatus: '10',
      classOptions: [
        { name: '全部', code: 'all' },
      ], // 班级下拉框列表
      schoolId: "", // 学校id
      tableData: [], // 危险预警列表
      tableLoading: false, // 列表加载状态...
      page: {
        pageSize: 10,
        pageNo: 1,
      }, // 分页信息
      total: 1, // 数据总条数
      dialogVisible: false,
      otherDataExist: true, // 是否有其他 已完成/处理中 数据
      noDataPageShow: true,
      cancelReason: "", // 手写取消原因
      cancelOption: [], // 选择取消原因
      cancelWarningUserId: '', // 解除预警学生id
      entryTime: Date.now(), // 进入页面时间
      zIndex: 0, // 弹窗的二次确认的层级
      isTeacher: true,
      allData: [],
      gradeOptions: [
        {
          "code": "12",
          "name": "高三",
          "children": [
            {
              "code": "1500000200060858251",
              "name": "2班",
              "children": null
            },
            {
              "code": "1500000200060858949",
              "name": "1班",
              "children": null
            }
          ]
        },
        {
          "code": "11",
          "name": "高二",
          "children": [
            {
              "code": "1500000200060858250",
              "name": "2班",
              "children": null
            },
            {
              "code": "1500000200060858948",
              "name": "1班改ER班",
              "children": null
            },
            {
              "code": "1500000200061003109",
              "name": "3班111",
              "children": null
            },
            {
              "code": "1500000200061003110",
              "name": "4班",
              "children": null
            },
            {
              "code": "1500000200061003111",
              "name": "5班",
              "children": null
            },
            {
              "code": "1500000200061003112",
              "name": "6班",
              "children": null
            },
            {
              "code": "1500000200061003113",
              "name": "7班",
              "children": null
            },
            {
              "code": "1500000200061003114",
              "name": "8班",
              "children": null
            },
            {
              "code": "1500000200061003115",
              "name": "9班",
              "children": null
            },
            {
              "code": "1500000200061003116",
              "name": "10班",
              "children": null
            },
            {
              "code": "1500000200061003117",
              "name": "11班",
              "children": null
            },
            {
              "code": "1500000200061003118",
              "name": "12班",
              "children": null
            },
            {
              "code": "1500000200061326437",
              "name": "二班",
              "children": null
            }
          ]
        },
        {
          "code": "10",
          "name": "高一",
          "children": [
            {
              "code": "1500000200060858946",
              "name": "1班改222",
              "children": null
            },
            {
              "code": "1500000200061325886",
              "name": "二班",
              "children": null
            },
            {
              "code": "1500000200061361373",
              "name": "2班改",
              "children": null
            }
          ]
        },
        {
          "code": "09",
          "name": "九年级",
          "children": [
            {
              "code": "1500000200060858248",
              "name": "1班",
              "children": null
            },
            {
              "code": "1500000200060858249",
              "name": "2班",
              "children": null
            }
          ]
        },
        {
          "code": "08",
          "name": "八年级",
          "children": [
            {
              "code": "1500000200060858944",
              "name": "1班",
              "children": null
            },
            {
              "code": "1500000200060858945",
              "name": "2班",
              "children": null
            }
          ]
        },
        {
          "code": "07",
          "name": "七年级",
          "children": [
            {
              "code": "1500000200060858246",
              "name": "1班",
              "children": null
            },
            {
              "code": "1500000200060858247",
              "name": "2班",
              "children": null
            }
          ]
        },
        {
          "code": "06",
          "name": "六年级",
          "children": [
            {
              "code": "1500000200060932480",
              "name": "1班",
              "children": null
            }
          ]
        },
        {
          "code": "05",
          "name": "五年级",
          "children": [
            {
              "code": "1500000200061488614",
              "name": "1班",
              "children": null
            },
            {
              "code": "1500000200061488615",
              "name": "2班",
              "children": null
            },
            {
              "code": "1500000200061488616",
              "name": "3班",
              "children": null
            }
          ]
        },
        {
          "code": "04",
          "name": "四年级",
          "children": [
            {
              "code": "1500000200060999374",
              "name": "1班",
              "children": null
            },
            {
              "code": "1500000200060999512",
              "name": "2班",
              "children": null
            }
          ]
        },
        {
          "code": "03",
          "name": "三年级",
          "children": [
            {
              "code": "1500000200060999372",
              "name": "1班改",
              "children": null
            }
          ]
        },
        {
          "code": "02",
          "name": "二年级",
          "children": null
        },
        {
          "code": "01",
          "name": "一年级",
          "children": [
            {
              "code": "1500000200061495361",
              "name": "一班改21",
              "children": null
            }
          ]
        }
      ],
      warningSourceOptions: [
        { 'value': 'all', 'name': '全部' },
        { "value": "1616648426951296", "name": "520任务" },
        { "value": "1616565527908992", "name": "区级任务1" },
        { "value": "1616126432383616", "name": "测试校3区级任务" },
        { "value": "1614340125513408", "name": "五月二十号" },
        { "value": "1615700406964864", "name": "hc的测试回归量表测评任务" },
        { "value": "1603180190258880", "name": "MSSMHS   中学生心理健康量表测评任务" },
        { "value": "1598756734392000", "name": "5.17心理健康" },
        { "value": "1591819204563584", "name": "tu5/16任务" },
        { "value": "1570565464199808", "name": "5.12任务1量表z分、t分、计次校验测评任务" },
        { "value": "1484256960975488", "name": "姜金奇测试修改" },
        { "value": "1565024636786368", "name": "PHQ-9抑郁自评量表测评任务" },
        { "value": "1485833976025728", "name": "MSSMHS   中学生心理健康量表测评任务" },
        { "value": "1440421497231040", "name": "PHQ-9抑郁自评量表测评任务" },
        { "value": "1486544461042304", "name": "4.27心理健康任务" },
        { "value": "1484065944786624", "name": "区4.27任务3：两个量表@" },
        { "value": "1440998803903104", "name": "校级1" },
        { "value": "1479845271393984", "name": "区4.26任务7：PHQ-9抑郁自评量表测评任务" },
        { "value": "1479718724964992", "name": "区4.26任务6：PHQ-9抑郁自评量表测评任务" },
        { "value": "1455658227798656", "name": "预警量表" },
        { "value": "b81b650442d4456b823cdb7848da9115", "name": "验证1" },
        { "value": "f572d321a5c64f6993dd2d0a237e0eb1", "name": "4.6心理健康群体" },
        { "value": "19da3ed5b9a6424885ff0b04c4928227", "name": "涂的预警量表（带范围名称）测评任务" },
        { "value": "0c7bcfc3628b4f52b655b08741feb40f", "name": "3.10:jc郑方磊心理健康量表2测评任务" },
        { "value": "a3607866077944c7bbead7e3b2341659", "name": "校级任务11" },
        { "value": "e8f20887cace4e4b84fa02497e96d722", "name": "3.17任务1：郑方磊心理健康量表2测评任务" },
        { "value": "6a648b7a116f4d158081dc96b9822236", "name": "11111" }
      ], // 预警来源下拉框列表
    };
  },
  computed: {
    modifyTimeTitle: function () {
      const sectionTitleMap = {
        10: "预警时间",
        30: "最新关注时间",
        40: "解除预警时间",
      };
      return sectionTitleMap[this.queryForm.warnStatus];
    },
  },
  watch: {},
  created () {
    // tab页
    this.queryForm.warnStatus = 10;
    this.tabWarnStatus = '10';
    this.getData(true, true);

  },
  mounted () { },
  methods: {
    // 根据预警等级显示
    getWarningStyle (warningLevel) {
      const classNameMap = ["one", "two", "three"]; // "four", "five"
      return classNameMap[warningLevel - 1] || 'one';
    },
    // 点击去处理中/已完成
    goWarnStatus (warnStatus) {
      this.queryForm.warnStatus = warnStatus;
      this.tabWarnStatus = String(warnStatus);
      this.getData();
    },
    tabClick (tab) {
      const status = Number(tab.name);
      if (this.queryForm.warnStatus !== status) {

        // 切换tab页时 上报埋点 不同tab页 上报id不同
        let eventId;
        switch (this.queryForm.warnStatus) {
          case 10:
            eventId = '28';
            break;
          case 30:
            eventId = '29';
            break;
          case 40:
            eventId = '30';
            break;
          default:
            break;
        }
        if (eventId) {
          const now = Date.now();
          this.entryTime = Date.now();
        }

        this.queryForm.warnStatus = status;
        this.tabWarnStatus = tab.name;
        this.getData();
      }
    },
    // 跳转心理档案
    openPsychology (row) {

    },
    // 重置搜索条件
    resetQuery () {

    },
    // 点击取消预警按钮
    cancelWarningBtn (row) {

    },
    // 切换学校
    selectSchool (value) {
      this.queryForm.gradeId = "all";

    },
    // 获取危险预警列表信息
    getData (initPageNo, checkDataExist) {
      let res = {
        "pageNo": 1,
        "pageSize": 10,
        "totalCount": 20,
        "dataList": [
          {
            "userId": "1500000200061498909",
            "userName": "tu6",
            "sex": null,
            "classId": "1500000200061495361",
            "className": "一班改21",
            "gradeCode": "01",
            "gradeName": "一年级",
            "warningLevel": 3,
            "warningLevelStr": "三级预警",
            "modifyTime": "2022-05-20 20:25",
            "modifyUser": "tu6",
            "sourceName": "520任务",
            "lastEvaRecordTime": null,
            "headmasterId": "1500000200061356713",
            "headmasterName": "心育3管理员",
            "userAgeInt": null,
            "warnStatus": 10,
            "genderCode": ""
          },
          {
            "userId": "1500000200061498908",
            "userName": "tu5",
            "sex": null,
            "classId": "1500000200061495361",
            "className": "一班改21",
            "gradeCode": "01",
            "gradeName": "一年级",
            "warningLevel": 3,
            "warningLevelStr": "三级预警",
            "modifyTime": "2022-05-20 20:24",
            "modifyUser": "tu5",
            "sourceName": "520任务",
            "lastEvaRecordTime": null,
            "headmasterId": "1500000200061356713",
            "headmasterName": "心育3管理员",
            "userAgeInt": null,
            "warnStatus": 10,
            "genderCode": ""
          },
          {
            "userId": "1500000200061495823",
            "userName": "三年级一号",
            "sex": null,
            "classId": "1500000200060999372",
            "className": "1班改",
            "gradeCode": "03",
            "gradeName": "三年级",
            "warningLevel": 3,
            "warningLevelStr": "三级预警",
            "modifyTime": "2022-05-20 17:52",
            "modifyUser": "三年级一号",
            "sourceName": "五月二十号",
            "lastEvaRecordTime": null,
            "headmasterId": "1500000200061495832",
            "headmasterName": "新增老师改",
            "userAgeInt": null,
            "warnStatus": 10,
            "genderCode": ""
          },
          {
            "userId": "1500000200060858263",
            "userName": "纪凌尘",
            "sex": null,
            "classId": "1500000200060858949",
            "className": "1班",
            "gradeCode": "12",
            "gradeName": "高三",
            "warningLevel": 3,
            "warningLevelStr": "三级预警",
            "modifyTime": "2022-05-17 16:35",
            "modifyUser": "纪凌尘",
            "sourceName": "5.17心理健康",
            "lastEvaRecordTime": null,
            "headmasterId": "1500000200060858961",
            "headmasterName": "心育测试老师1",
            "userAgeInt": null,
            "warnStatus": 10,
            "genderCode": ""
          },
          {
            "userId": "1500000200060858958",
            "userName": "宵夜lsn改",
            "sex": 0,
            "classId": "1500000200060858946",
            "className": "1班改222",
            "gradeCode": "10",
            "gradeName": "高一",
            "warningLevel": 3,
            "warningLevelStr": "三级预警",
            "modifyTime": "2022-05-12 16:36",
            "modifyUser": "宵夜",
            "sourceName": "姜金奇测试修改",
            "lastEvaRecordTime": null,
            "headmasterId": "1500000200061495365",
            "headmasterName": "新增心理二号老师",
            "userAgeInt": null,
            "warnStatus": 10,
            "genderCode": "0"
          },
          {
            "userId": "1500000200060858951",
            "userName": "小颜",
            "sex": null,
            "classId": "1500000200060858247",
            "className": "2班",
            "gradeCode": "07",
            "gradeName": "七年级",
            "warningLevel": 3,
            "warningLevelStr": "三级预警",
            "modifyTime": "2022-04-28 14:28",
            "modifyUser": "小颜",
            "sourceName": "PHQ-9抑郁自评量表测评任务",
            "lastEvaRecordTime": null,
            "headmasterId": null,
            "headmasterName": null,
            "userAgeInt": null,
            "warnStatus": 10,
            "genderCode": ""
          },
          {
            "userId": "1500000200061195418",
            "userName": "高三学生001",
            "sex": null,
            "classId": "1500000200060858949",
            "className": "1班",
            "gradeCode": "12",
            "gradeName": "高三",
            "warningLevel": 3,
            "warningLevelStr": "三级预警",
            "modifyTime": "2022-04-28 09:55",
            "modifyUser": "高三学生001",
            "sourceName": "4.27心理健康任务",
            "lastEvaRecordTime": null,
            "headmasterId": "1500000200060858961",
            "headmasterName": "心育测试老师1",
            "userAgeInt": null,
            "warnStatus": 10,
            "genderCode": ""
          },
          {
            "userId": "1500000200061041982",
            "userName": "杰克",
            "sex": null,
            "classId": "1500000200060858949",
            "className": "1班",
            "gradeCode": "12",
            "gradeName": "高三",
            "warningLevel": 3,
            "warningLevelStr": "三级预警",
            "modifyTime": "2022-04-28 09:54",
            "modifyUser": "杰克",
            "sourceName": "4.27心理健康任务",
            "lastEvaRecordTime": null,
            "headmasterId": "1500000200060858961",
            "headmasterName": "心育测试老师1",
            "userAgeInt": null,
            "warnStatus": 10,
            "genderCode": ""
          },
          {
            "userId": "1500000200060858252",
            "userName": "丽丽李",
            "sex": 1,
            "classId": "1500000200060858246",
            "className": "1班",
            "gradeCode": "07",
            "gradeName": "七年级",
            "warningLevel": 3,
            "warningLevelStr": "三级预警",
            "modifyTime": "2022-04-26 18:49",
            "modifyUser": "丽丽李",
            "sourceName": "校级1",
            "lastEvaRecordTime": null,
            "headmasterId": "1500000200060858961",
            "headmasterName": "心育测试老师1",
            "userAgeInt": null,
            "warnStatus": 10,
            "genderCode": "1"
          },
          {
            "userId": "1500000200060858259",
            "userName": "润润",
            "sex": null,
            "classId": "1500000200060858948",
            "className": "1班改ER班",
            "gradeCode": "11",
            "gradeName": "高二",
            "warningLevel": 3,
            "warningLevelStr": "三级预警",
            "modifyTime": "2022-04-06 17:01",
            "modifyUser": "xyls003",
            "sourceName": "验证1",
            "lastEvaRecordTime": null,
            "headmasterId": null,
            "headmasterName": null,
            "userAgeInt": null,
            "warnStatus": 10,
            "genderCode": ""
          },
          {
            "userId": "1500000200061195419",
            "userName": "高三学生002",
            "sex": null,
            "classId": "1500000200060858949",
            "className": "1班",
            "gradeCode": "12",
            "gradeName": "高三",
            "warningLevel": 3,
            "warningLevelStr": "三级预警",
            "modifyTime": "2022-03-25 14:00",
            "modifyUser": "高三学生002",
            "sourceName": "3.10:jc郑方磊心理健康量表2测评任务",
            "lastEvaRecordTime": null,
            "headmasterId": "1500000200060858961",
            "headmasterName": "心育测试老师1",
            "userAgeInt": null,
            "warnStatus": 10,
            "genderCode": ""
          },
          {
            "userId": "1500000200061196067",
            "userName": "高三学生200",
            "sex": null,
            "classId": "1500000200060858949",
            "className": "1班",
            "gradeCode": "12",
            "gradeName": "高三",
            "warningLevel": 3,
            "warningLevelStr": "三级预警",
            "modifyTime": "2022-03-18 15:22",
            "modifyUser": "高三学生200",
            "sourceName": "3.17任务1：郑方磊心理健康量表2测评任务",
            "lastEvaRecordTime": null,
            "headmasterId": "1500000200060858961",
            "headmasterName": "心育测试老师1",
            "userAgeInt": null,
            "warnStatus": 10,
            "genderCode": ""
          },
          {
            "userId": "1500000200061196066",
            "userName": "高三学生199",
            "sex": null,
            "classId": "1500000200060858949",
            "className": "1班",
            "gradeCode": "12",
            "gradeName": "高三",
            "warningLevel": 3,
            "warningLevelStr": "三级预警",
            "modifyTime": "2022-03-18 15:22",
            "modifyUser": "高三学生199",
            "sourceName": "3.17任务1：郑方磊心理健康量表2测评任务",
            "lastEvaRecordTime": null,
            "headmasterId": "1500000200060858961",
            "headmasterName": "心育测试老师1",
            "userAgeInt": null,
            "warnStatus": 10,
            "genderCode": ""
          },
          {
            "userId": "1500000200061196065",
            "userName": "高三学生198",
            "sex": null,
            "classId": "1500000200060858949",
            "className": "1班",
            "gradeCode": "12",
            "gradeName": "高三",
            "warningLevel": 3,
            "warningLevelStr": "三级预警",
            "modifyTime": "2022-03-18 15:22",
            "modifyUser": "高三学生198",
            "sourceName": "3.17任务1：郑方磊心理健康量表2测评任务",
            "lastEvaRecordTime": null,
            "headmasterId": "1500000200060858961",
            "headmasterName": "心育测试老师1",
            "userAgeInt": null,
            "warnStatus": 10,
            "genderCode": ""
          },
          {
            "userId": "1500000200061196064",
            "userName": "高三学生197",
            "sex": null,
            "classId": "1500000200060858949",
            "className": "1班",
            "gradeCode": "12",
            "gradeName": "高三",
            "warningLevel": 3,
            "warningLevelStr": "三级预警",
            "modifyTime": "2022-03-18 15:22",
            "modifyUser": "高三学生197",
            "sourceName": "3.17任务1：郑方磊心理健康量表2测评任务",
            "lastEvaRecordTime": null,
            "headmasterId": "1500000200060858961",
            "headmasterName": "心育测试老师1",
            "userAgeInt": null,
            "warnStatus": 10,
            "genderCode": ""
          },
          {
            "userId": "1500000200061196062",
            "userName": "高三学生195",
            "sex": null,
            "classId": "1500000200060858949",
            "className": "1班",
            "gradeCode": "12",
            "gradeName": "高三",
            "warningLevel": 3,
            "warningLevelStr": "三级预警",
            "modifyTime": "2022-03-18 15:22",
            "modifyUser": "高三学生195",
            "sourceName": "3.17任务1：郑方磊心理健康量表2测评任务",
            "lastEvaRecordTime": null,
            "headmasterId": "1500000200060858961",
            "headmasterName": "心育测试老师1",
            "userAgeInt": null,
            "warnStatus": 10,
            "genderCode": ""
          },
          {
            "userId": "1500000200061196063",
            "userName": "高三学生196",
            "sex": null,
            "classId": "1500000200060858949",
            "className": "1班",
            "gradeCode": "12",
            "gradeName": "高三",
            "warningLevel": 3,
            "warningLevelStr": "三级预警",
            "modifyTime": "2022-03-18 15:22",
            "modifyUser": "高三学生196",
            "sourceName": "3.17任务1：郑方磊心理健康量表2测评任务",
            "lastEvaRecordTime": null,
            "headmasterId": "1500000200060858961",
            "headmasterName": "心育测试老师1",
            "userAgeInt": null,
            "warnStatus": 10,
            "genderCode": ""
          },
          {
            "userId": "1500000200061196060",
            "userName": "高三学生193",
            "sex": null,
            "classId": "1500000200060858949",
            "className": "1班",
            "gradeCode": "12",
            "gradeName": "高三",
            "warningLevel": 3,
            "warningLevelStr": "三级预警",
            "modifyTime": "2022-03-18 15:22",
            "modifyUser": "高三学生193",
            "sourceName": "3.17任务1：郑方磊心理健康量表2测评任务",
            "lastEvaRecordTime": null,
            "headmasterId": "1500000200060858961",
            "headmasterName": "心育测试老师1",
            "userAgeInt": null,
            "warnStatus": 10,
            "genderCode": ""
          },
          {
            "userId": "1500000200061196061",
            "userName": "高三学生194",
            "sex": null,
            "classId": "1500000200060858949",
            "className": "1班",
            "gradeCode": "12",
            "gradeName": "高三",
            "warningLevel": 3,
            "warningLevelStr": "三级预警",
            "modifyTime": "2022-03-18 15:22",
            "modifyUser": "高三学生194",
            "sourceName": "3.17任务1：郑方磊心理健康量表2测评任务",
            "lastEvaRecordTime": null,
            "headmasterId": "1500000200060858961",
            "headmasterName": "心育测试老师1",
            "userAgeInt": null,
            "warnStatus": 10,
            "genderCode": ""
          },
          {
            "userId": "1500000200061196058",
            "userName": "高三学生191",
            "sex": null,
            "classId": "1500000200060858949",
            "className": "1班",
            "gradeCode": "12",
            "gradeName": "高三",
            "warningLevel": 3,
            "warningLevelStr": "三级预警",
            "modifyTime": "2022-03-18 15:22",
            "modifyUser": "高三学生191",
            "sourceName": "3.17任务1：郑方磊心理健康量表2测评任务",
            "lastEvaRecordTime": null,
            "headmasterId": "1500000200060858961",
            "headmasterName": "心育测试老师1",
            "userAgeInt": null,
            "warnStatus": 10,
            "genderCode": ""
          }
        ],
        "maxOptionNum": null
      }
      this.allData = res.dataList;
      this.tableData = this.allData.slice(0, 10);
      this.total = res.totalCount;
      this.page.pageSize = res.pageSize;
      this.page.pageNo = res.pageNo;
    },
    // 查看预警信息
    warningDetail (row) {

    },
    // 处理页数变化
    handleCurrent (val) {
      this.page.pageNo = val;
      if (val === 1) {
        this.tableData = this.allData.slice(0, 10);
      } else {
        this.tableData = this.allData.slice(10 * (this.page.pageNo - 1), 10 * this.page.pageNo);
        console.log(this.tableData);
      }
    },
    // 选择年级
    selectGradeAndGetClassOptions (val) {
      this.queryForm.classId = "all";
      this.classOptions = [];
      if (val === 'all') {
        this.classOptions = [
          { name: '全部', code: 'all' },
        ];
      } else {
        let classData = this.gradeOptions.filter(item => {
          if (item.code === val) {
            return item;
          }
        })[0].children;
        classData.unshift({ name: '全部', code: 'all' });
        this.classOptions = classData;
      }
      console.log(val);

    },
  },
  beforeRouteLeave (to, from, next) {
    next();
  },
};
</script>

<style scoped lang="scss">
// @import '';
.crisisWarning {
  // padding: 24px 24px 0px;
  min-height: calc(100vh - 55px);
  .title {
    margin: 16px 0;
    padding-left: 24px;
    background: #fff;
    height: 56px;
    line-height: 56px;
    border-radius: 4px;
    font-weight: 500;
    color: #262626;
    font-size: 16px;
    span {
      margin-left: 12px;
      font-size: 14px;
      color: #595959;
      font-weight: 400;
    }
  }
  h4 {
    margin-top: 0;
  }
  .tabs {
    padding: 0 24px 24px;
    background: #fff;
    position: relative;
    .graduate-student {
      position: absolute;
      right: 24px;
      top: 0;
    }
    .query-form {
      position: relative;
      .form-item-select {
        width: 155px;
      }
      .class-select {
        display: inline-block;
        margin-left: 6px;
      }
      // .cancleBtn {
      //   position: absolute;
      //   right: -20px;
      // }
    }
    /deep/.el-dialog__body {
      padding: 0;
      border-top: 1px solid rgba(0, 0, 0, 0.09);
      border-bottom: 1px solid rgba(0, 0, 0, 0.09);
    }

    .dialog-des {
      height: 40px;
      padding-left: 24px;
      background: #fff7e8;
      line-height: 40px;
      margin-bottom: 16px;

      img {
        width: 16px;
        height: 16px;
        vertical-align: text-bottom;
        margin-right: 8px;
      }
    }
    .interactive-container {
      padding: 0 24px 24px;
      .radio-des {
        margin-bottom: 16px;
      }
      .cancel-reason {
        width: 400px;
        margin-top: 16px;
      }
    }

    .submit-btn {
      width: 88px;
    }
    .tables {
      margin-bottom: 20px;
      .warning-level-block {
        font-size: 12px;
        padding-left: 8px;
        width: 84px;
        height: 22px;
        border-radius: 3px;
        img {
          width: 16px;
          height: 16px;
          vertical-align: text-bottom;
          margin-right: 4px;
        }
      }
      .one {
        background: rgba(255, 169, 12, 0.1);
        color: rgba(255, 169, 12, 1);
        img {
          content: url('../../assets/images/warning-level-1.png');
        }
      }
      .two {
        background: rgba(255, 127, 33, 0.1);
        color: rgba(255, 127, 33, 1);
        img {
          content: url('../../assets/images/warning-level-2.png');
        }
      }
      .three {
        background: rgba(255, 73, 11, 0.1);
        color: rgba(255, 73, 11, 1);
        img {
          content: url('../../assets/images/warning-level-3.png');
        }
      }
      .four {
        background: rgba(246, 30, 1, 0.1);
        color: rgba(246, 30, 1, 1);
        img {
          content: url('../../assets/images/warning-level-4.png');
        }
      }
      .five {
        background: rgba(231, 1, 1, 0.1);
        color: rgba(231, 1, 1, 1);
        img {
          content: url('../../assets/images/warning-level-5.png');
        }
      }
    }
    .no-warning-data {
      color: #8c8c8c;
      text-align: center;
      span {
        color: #368fff;
        cursor: pointer;
      }
    }
    .opeatBtn {
      padding: 0;
    }
  }
}
.el-form-item {
  margin-bottom: 8px;
  // margin-right: 24px;
}
/deep/.el-form-item__label {
  width: 70px;
  padding: 0 4px 0 0;
}

/deep/.el-tabs__item {
  height: 48px;
  line-height: 48px;
  font-weight: 400;
}

/deep/.el-tabs__nav-wrap::after {
  height: 1px;
  background-color: #f0f1f4;
}
</style>
